import { COMMON_PAGE_LIMIT, prepareIdsForChunking } from '@wix/a11y-wizard-common';
import { queryServices } from '@wix/ambassador-bookings-services-v2-service/http';
export const fetchServicePages = async (httpClient, errorHandler, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  return withErrorHandler(async () => {
    const idChunks = prepareIdsForChunking(ids, COMMON_PAGE_LIMIT);
    const chunkPromises = idChunks.map(async idChunk => {
      const chunkServices = [];
      let cursor;
      do {
        var _pagingMetadata$curso;
        const {
          data: {
            services,
            pagingMetadata
          }
        } = await httpClient.request(queryServices({
          query: {
            cursorPaging: {
              cursor,
              limit: COMMON_PAGE_LIMIT
            },
            filter: idChunk.length > 0 ? {
              id: {
                $in: idChunk
              }
            } : undefined
          }
        }));
        cursor = pagingMetadata == null || (_pagingMetadata$curso = pagingMetadata.cursors) == null ? void 0 : _pagingMetadata$curso.next;
        chunkServices.push(...(services ?? []));
      } while (cursor);
      return chunkServices;
    });
    const results = await Promise.all(chunkPromises);
    return results.flat();
  }, {
    errorCodesMap: {}
  });
};
//# sourceMappingURL=fetch-services.js.map